export default __webpack_public_path__ + "static/media/landscape.af338ff2.jpg";